import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./app.css";

window.addEventListener("unhandledrejection", (event) => {
  console.error("[unhandledRejection]", event.reason);
});

// biome-ignore lint/style/noNonNullAssertion: #root is always present in index.html
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
